module.exports = __webpack_public_path__ + "static/media/Mp3_Pause.37397260.svg";